import React from 'react'
import { inject, observer } from 'mobx-react'
import classNames from 'classnames'
import { Marker, ScaleControl } from 'react-leaflet'
import CustomMap from './CustomMap'
import BaseLayer from './BaseLayer'
import DrawLayer from './DrawLayer'
import Overlays from './Overlays'
import BoundaryOverlays from './BoundaryOverlays'
import PinIcon from '../../../src/components/common/icons/PinIcon'
import VectorTileLayer from './VectorTileLayer'
import QuickCreateOverlay from './QuickCreateOverlay'
import { selectionTypes } from '../../constants'
// import SearchAreaRectangle from './SearchAreaRectangle'

// Render the custom map, and pass mouse events along
// to the currently-selected item.
const MapContainer = ({ uiStore, selectionStore, printMap }) => {
  const isAddItemFlow =
    selectionStore.type === selectionTypes.NEW_ITEM ||
    selectionStore.type === selectionTypes.NEW_TARGET_GROUP ||
    selectionStore.type === 'FOLDER_ACTIONS' ||
    selectionStore.type === selectionTypes.BULK_POINT_BUFFER ||
    selectionStore.type === selectionTypes.BULK_ISOCHRONE ||
    selectionStore.type === selectionTypes.USER_SHAPEFILE_LIST ||
    selectionStore.type === selectionTypes.USER_MARKERFILE_LIST ||
    ((selectionStore.type === selectionTypes.POINT_BUFFER ||
      selectionStore.type === selectionTypes.SHAPE ||
      selectionStore.type === selectionTypes.LINE ||
      selectionStore.type === selectionTypes.ISOCHRONE) &&
      (!selectionStore.item || !selectionStore.item.isUpdating)) ||
    (selectionStore.type === selectionTypes.MARKER && (!selectionStore.data || !selectionStore.data.edit)) ||
    uiStore.isAddChoiceTypeVisible
  const isBoundsSuppressed = uiStore.suppressBoundsUntil > Date.now()
  const boundsProp = (isAddItemFlow || isBoundsSuppressed) ? undefined : uiStore.bounds

  return (
    <div className={classNames({ map: true, 'map--fullwidth': uiStore.sideMenuHidden })} style={{ '--menu-width': `${uiStore.menuWidth}px` }}>
      <CustomMap
        viewport={uiStore.viewport}
        bounds={boundsProp}
        boundsOptions={{
          paddingTopLeft: printMap
            ? uiStore.printLeftOffset
            : uiStore.boundsTopLeftOffset,
          paddingBottomRight: printMap
            ? uiStore.printRightOffset
            : uiStore.boundsBottomRightOffset
        }}
        printMap={printMap}
        detectRetina
        zoomSnap={0}
        onMousedown={e => {
          if (e && e.originalEvent && e.originalEvent.target) {
            if (e.originalEvent.target.closest && e.originalEvent.target.closest('.quick-create-wrapper, .quick-create-top-card, .quick-create-menu-card, .quick-create-card, .quick-create-form-card, .quick-create-leaflet-tooltip, .quick-create-modal')) {
              return
            }
          }
          if (uiStore.quickCreate.isOpen && !uiStore.quickCreate.activeModal) {
            uiStore.closeQuickCreate()
          }
          selectionStore.passEvent('mapMousedown', e)
        }}
        onMouseup={e => selectionStore.passEvent('mapMouseup', e)}
        onMousemove={e => selectionStore.passEvent('mapMousemove', e)}
        onDblclick={e => selectionStore.passEvent('mapDblclick', e)}
        onContextmenu={e => {
          if (e && e.originalEvent) {
            e.originalEvent.preventDefault()
          }
          if (e && e.latlng) {
            uiStore.openQuickCreate(e.latlng)
          }
        }}
      >
        {selectionStore.item && selectionStore.item.selectedBoundary && !selectionStore.item.selectedBoundary.is_zip_code && <VectorTileLayer key={selectionStore.item.selectedBoundary.id} />}
        <DrawLayer printMap={printMap} />
        <BoundaryOverlays />
        {/* <ChildrenOverlays /> */}
        <Overlays />
        <BaseLayer />
        <QuickCreateOverlay />
        {/* <SearchAreaRectangle /> */}
        <ScaleControl position='bottomright' />
        {uiStore.location ? <Marker position={uiStore.location} icon={PinIcon} /> : null}
      </CustomMap>
    </div>
  )
}

export default inject('uiStore', 'selectionStore')(
  observer(MapContainer)
)
